module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticClass: "table-shin-expand",
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._l((_vm.NotSentProductLotLines(props.row.LotLines)), function(row) {
          return _c('div', {
            key: row.Id,
            staticClass: "inner-list"
          }, [_c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("批次号")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.LotCode))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item",
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('el-tag', {
            staticStyle: {
              "margin-top": "8px"
            },
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(row.ConditionName))])], 1), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁周期：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.RentalPeriod) + "个月")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("折扣：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.DiscountRate * 100) + "%")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁单价：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalUnitPrice))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("保修：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.WarrantyAmount) + "/" + _vm._s(row.WarrantyMonths * 30) + "天")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租金：\n            "), _c('el-tooltip', {
            attrs: {
              "popper-class": "blue-tooltip",
              "effect": "dark",
              "content": "租赁单价*数量+保修费用",
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "el-icon-information"
          })])], 1), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalAmount))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("押金：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.Deposit))])])])
        }), _vm._v(" "), (_vm.SentProductLotLines(props.row.LotLines).length) ? _c('p', {
          staticClass: "sent-lot-title"
        }, [_vm._v("已发货批次")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.SentProductLotLines(props.row.LotLines)), function(row) {
          return _c('div', {
            key: row.Id,
            staticClass: "inner-list"
          }, [_c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("批次号")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.LotCode))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item",
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('span', {
            staticClass: "el-tag el-tag--primary",
            staticStyle: {
              "margin-top": "8px"
            }
          }, [_vm._v(_vm._s(row.ConditionName))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁周期：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.RentalPeriod) + "个月")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("折扣：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.DiscountRate * 100) + "%")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁单价：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalUnitPrice))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("保修：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.WarrantyAmount) + "/" + _vm._s(row.WarrantyMonths * 30) + "天")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租金：\n            "), _c('el-tooltip', {
            attrs: {
              "popper-class": "blue-tooltip",
              "effect": "dark",
              "content": "租赁单价*数量+保修费用",
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "el-icon-information"
          })])], 1), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalAmount))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("押金：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.Deposit))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('el-button', {
            attrs: {
              "type": "text"
            }
          }, [_vm._v("查看物流")])], 1)])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.ProductName))]), _vm._v(" "), _c('p', {
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户物料名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.CustomerProductName))]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.CustomerProductCode),
            expression: "props.row.CustomerProductCode"
          }],
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.CustomerProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "BrandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "ModelName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "ModuleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "租赁数量",
      "prop": "RentalQuantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保修期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.WarrantyMonths) + "个月/" + _vm._s(props.row.WarrantyAmount) + "元")]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9abebb9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Lease/LeaseDetailTableNormal.vue
// module id = 762
// module chunks = 0